(function () {
    'use strict';

    angular.module('loginModule', [])
        .controller('loginCon', ['$scope', 'AuthSrv', 'Session', 'APRO_BME_URL', loginController]);

    function loginController($scope, AuthSrv, Session, APRO_BME_URL) {
        $scope.title = 'Login';
        $scope.user = '';
        $scope.password = '';

        $scope.login = function () {
            AuthSrv
                .authUser($scope.user, $scope.password)
                .success(function(res){
                    if(res.Token) {
                            Session.create(res.Token, res.ClientId);
                            AuthSrv.isAuthenticated().then(function(isAuthenticated) {
                                if (isAuthenticated) {
                                    window.location = APRO_BME_URL;
                                    location.reload(true);
                                }
                            });
                        } else {
                            alert('user or password is incorrect');
                        }

                })
                .error(function(err){
                    console.log(err);
                    alert('something went wrong witht the login');
                });
        };
    }

})();



// WEBPACK FOOTER //
// ./app/controllers/loginController.js